
import Vue from "vue";
import {getCompanyName} from "~/assets/config/brandNames";

export default Vue.extend({
  name: "PortalFooter",
  computed: {
    brandName(): string {
      return getCompanyName(process.env.AGENT);
    },
  },
});
